<template>
  <ion-page>
    <ion-header />
    <ion-content :scroll-events="enableScrollEvent" @ionScroll="onScroll">
      <slot></slot>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonHeader, IonContent } from '@ionic/vue';
import { lockToPortrait } from '@/utils/screen-orientation';

export default {
  components: {
    IonPage,
    IonHeader,
    IonContent,
  },
  props: {
    enableScrollEvent: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onScroll(event) {
      this.$emit('on-scroll', event);
    },
  },
  async mounted() {
    await lockToPortrait();
  },
  async beforeUnmount() {
    await lockToPortrait();
  },
};
</script>
